import Vue from 'vue'
import BaseH1 from './BaseH1.vue'
import BaseBtn from './BaseBtn.vue'
import BaseText from './BaseText.vue'
import SelectableChip from './SelectableChip.vue'

Vue.component(BaseH1.name, BaseH1)
Vue.component(BaseBtn.name, BaseBtn)
Vue.component(BaseText.name, BaseText)
Vue.component(SelectableChip.name, SelectableChip)

export default {}
